<template>
  <div class="expand-item-container">
    <div class="expand-item">
      商品编码：{{row.purchaseMedicineDrugSerialCode}}
    </div>
    <div class="expand-item">
      {{licenseLabel}}：{{row.medicineInfoVoApprovalCode}}
    </div>
    <div class="expand-item">
      商品名称：{{row.medicineInfoVoGoodsName}}
    </div>
    <div class="expand-item">
      待收货数量：{{row.purchaseMedicineTodoReceiptNum}}
    </div>
    <div class="expand-item">
      计划数量：{{row.purchaseMedicineNum}}
    </div>
    <div class="expand-item">
      计划单价：{{row.purchaseMedicinePlanPrice}}
    </div>
    <div class="expand-item">
      剂型：{{row.medicineInfoVoDosageFormString}}
    </div>
    <div class="expand-item">
      单位：{{row.purchaseMedicineDrugMinimumPackagingUnit}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'DoReceiptExpand',
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    goodsType: {
      type: Number,
    },
  },
  computed: {
    licenseLabel() {
      let label = '';
      if (this.goodsType === 2) {
        label = '注册证号/备案号';
      } else {
        label = '批准文号';
      }
      return label;
    },
  },
};
</script>
